import { Loader } from 'components';
import useTimeZone from 'hooks/use-timezone';
import { FC, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getCustomerReportGroupById } from 'services/customer-report-groups';
import { CustomerReportGroup } from 'types';
import { parseEmailList } from 'utils/format';


export const ViewReport: FC = () => {
    const navigate = useNavigate();
    const params = useParams();
    const { timeZoneIndicator, timeZoneOffset } = useTimeZone();

    const [reportGroup, setReportGroup] = useState<CustomerReportGroup | null>(null);

    useEffect(() => {
        if (!!params.id && !isNaN(Number(params.id))) {
            getCustomerReportGroupById(Number(params.id)).then(setReportGroup);
        }
    }, [params.id]);

    return (
        <>
            <Loader loading={!reportGroup}>
                {!!reportGroup && (
                    <div className="page" id="report-group-details">
                        <div className="page-header">
                            <h1>REPORT GROUP: {reportGroup?.name ? `${reportGroup?.name}` : 'N/A'}</h1>
                            <div className="d-flex g-3 flex-row-reverse">
                                <button
                                    className="btn-primary text-uppercase"
                                    onClick={() => navigate('edit', { replace: true })}
                                    data-cy="customer-report-group-edit-button"
                                >
                                    Edit
                                </button>
                                <button className="btn-back" onClick={() => navigate('/settings/report-groups', { replace: true })}>
                                    <span className="material-icons">arrow_back_ios</span>
                                    BACK
                                </button>
                            </div>
                        </div>
                        <div className="card-primary">
                            <div className="card-header px-3">
                                <h4 className="text-uppercase">Report Group Information</h4>
                            </div>
                            <div className="card-body">
                                <div className="grid-6 p-2">
                                    <div>
                                        <h6 className="text-dark font-weight-regular">Name</h6>
                                        <p className="text-black">{reportGroup?.name}</p>
                                    </div>
                                    <div>
                                        <h6 className="text-dark font-weight-regular">Activity Report ({timeZoneIndicator})</h6>
                                        <p className="text-black">
                                            {!reportGroup.activityReportHours?.length
                                                ? 'None'
                                                : reportGroup.activityReportHours
                                                    .map((utcHour: number) => (24 + utcHour + timeZoneOffset) % 24)
                                                    .sort()
                                                    .map((hour: number) => `${hour % 12 || 12}${hour < 12 ? 'AM' : 'PM'}`)
                                                    .join(', ')}
                                        </p>
                                    </div>
                                    <div>
                                        <h6 className="text-dark font-weight-regular">Status Report ({timeZoneIndicator})</h6>
                                        <p className="text-black">
                                            {!reportGroup.statusReportHours?.length
                                                ? 'None'
                                                : reportGroup.statusReportHours
                                                    .map((utcHour: number) => (24 + utcHour + timeZoneOffset) % 24)
                                                    .sort()
                                                    .map((hour: number) => `${hour % 12 || 12}${hour < 12 ? 'AM' : 'PM'}`)
                                                    .join(', ')}
                                        </p>
                                    </div>
                                    <div>
                                        <h6 className="text-dark font-weight-regular">Inventory Report ({timeZoneIndicator})</h6>
                                        <p className="text-black">
                                            {!reportGroup.inventoryReportHours?.length
                                                ? 'None'
                                                : reportGroup.inventoryReportHours
                                                    .map((utcHour: number) => (24 + utcHour + timeZoneOffset) % 24)
                                                    .sort()
                                                    .map((hour: number) => `${hour % 12 || 12}${hour < 12 ? 'AM' : 'PM'}`)
                                                    .join(', ')}
                                        </p>
                                    </div>
                                    <div>
                                        <h6 className="text-dark font-weight-regular">Emails</h6>
                                        <p className="text-black">
                                            {parseEmailList(reportGroup.email).join(', ') || 'None'}
                                        </p>
                                    </div>
                                    <div>
                                        <h6 className="text-dark font-weight-regular">Timezone</h6>
                                        <p className='text-black font-weight-regular'>{reportGroup.timezone}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="grid-auto">
                            <div className="card-primary">
                                <div className="card-header px-3">
                                    <h4 className="text-uppercase">Customer (s)</h4>
                                </div>
                                <div className="card-body">
                                    {
                                        (reportGroup.customers ?? []).map(({ id, name }) => {
                                            return (
                                                <div className="tag g-2 margin-top-8px margin-right-8px" key={id} data-cy={`new-report-group-account-${id}-tag`}>
                                                    <p className="text-primary">{name}</p>
                                                </div>
                                            );
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </Loader>
        </>
    );
};